@if (
  matchedConnections.length > 0 ||
  (matchedConnectionsWithLoanAmount &&
    matchedConnectionsWithLoanAmount.length > 0)
) {
  <div class="matched-cdfis-section" id="tour-matched-cdfis">
    <div class="section-header">
      <h4>MATCHED CDFIs</h4>
      <span class="matches-count">{{ matchedConnections.length }}</span>
    </div>

    <div class="matching-description">
      @if (
        matchedConnectionsWithLoanAmount &&
        matchedConnectionsWithLoanAmount.length > 0
      ) {
        <span
          class="view-loan-connections"
          (click)="
            showConnectionsWithLoanAmount = !showConnectionsWithLoanAmount
          "
          (keydown.enter)="
            showConnectionsWithLoanAmount = !showConnectionsWithLoanAmount
          "
          tabindex="0"
        >
          View connections that service loan amount
        </span>
      }
      @if (matchedConnections.length > 0) {
        <p class="matched-text">
          This record has been matched to the following CDFIs based on the lead
          criteria:
        </p>
      } @else {
        <p class="matched-text text-center">
          There are no matched CDFIs for this record.
        </p>
      }
    </div>

    @if (matchedConnections.length > 0) {
      <div class="cdfi-matches">
        @for (cdfi of matchedConnections; track $index) {
          <div
            class="cdfi-match fade-in"
            [class.current-user]="isCurrentUserConnection(cdfi)"
            [attr.tabindex]="0"
            (click)="onMatchedRecordDetails(cdfi)"
            (keydown.enter)="onMatchedRecordDetails(cdfi)"
          >
            <div class="cdfi-icon">
              <svg viewBox="0 0 512 512" fill="currentColor">
                <path
                  d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"
                />
              </svg>
            </div>
            <div class="cdfi-info">
              <div class="cdfi-name">
                {{ cdfi.display_name || cdfi.connection_name }}
              </div>
              <div class="cdfi-meta">
                <span class="meta-tag meta-products">
                  {{ getDistinctProducts(cdfi).length }} Product{{
                    getDistinctProducts(cdfi).length === 1 ? "" : "s"
                  }}
                </span>
                <span class="meta-tag meta-criteria">
                  {{ cdfi.matched_criterias.length }} Criteria
                </span>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}

@if (showDetailsPopup && matchedRecordDetails) {
  <app-popup
    [class]="
      'matched-details-popup' + (!showFullDetails ? ' summary-only' : '')
    "
    [heading]="
      (matchedRecordDetails.display_name ||
        matchedRecordDetails.connection_name) + ' - Match Details'
    "
    [showFooterButtons]="false"
    [showCloseIcon]="true"
    (cancelClicked)="showDetailsPopup = false"
  >
    <div
      [class]="
        'popup-content details' + (!showFullDetails ? ' summary-only' : '')
      "
    >
      <section class="popup-section details-section">
        <div class="summary-stats-container">
          <div class="summary-stat-card">
            <div class="summary-stat-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M11.25 4.533A9.707 9.707 0 006 3a9.735 9.735 0 00-3.25.555.75.75 0 00-.5.707v14.25a.75.75 0 001 .707A8.237 8.237 0 016 18.75c1.995 0 3.823.707 5.25 1.886V4.533zM12.75 20.636A8.214 8.214 0 0118 18.75c.966 0 1.89.166 2.75.47a.75.75 0 001-.708V4.262a.75.75 0 00-.5-.707A9.735 9.735 0 0018 3a9.707 9.707 0 00-5.25 1.533v16.103z"
                />
              </svg>
            </div>
            <div class="summary-stat-content">
              <div class="summary-stat-value">
                {{ matchedRecordDetails.matched_criterias.length }}
              </div>
              <div class="summary-stat-label-row">
                <span class="summary-stat-label">Criteria Matched</span>
                <span
                  class="info-icon"
                  title="Number of matching criteria sets that this record satisfies based on lead requirements"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <div class="summary-stat-card">
            <div class="summary-stat-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.502 6h7.128A3.375 3.375 0 0118 9.375v9.375a3 3 0 003-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 00-.673-.05A3 3 0 0015 1.5h-1.5a3 3 0 00-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6zM13.5 3A1.5 1.5 0 0012 4.5h4.5A1.5 1.5 0 0015 3h-1.5z"
                  clip-rule="evenodd"
                />
                <path
                  fill-rule="evenodd"
                  d="M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V9.375zm9.586 4.594a.75.75 0 00-1.172-.938l-2.476 3.096-.908-.907a.75.75 0 00-1.06 1.06l1.5 1.5a.75.75 0 001.116-.062l3-3.75z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div class="summary-stat-content">
              <div class="summary-stat-value">
                {{ getDistinctProducts(matchedRecordDetails).length }}
              </div>
              <div class="summary-stat-label-row">
                <span class="summary-stat-label">Products Matched</span>
                <span
                  class="info-icon"
                  title="Total number of unique products that match this record across all criteria"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <div class="summary-stat-card">
            <div class="summary-stat-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.25 13.5a8.25 8.25 0 018.25-8.25.75.75 0 01.75.75v6.75H18a.75.75 0 01.75.75 8.25 8.25 0 01-16.5 0z"
                  clip-rule="evenodd"
                />
                <path
                  fill-rule="evenodd"
                  d="M12.75 3a.75.75 0 01.75-.75 8.25 8.25 0 018.25 8.25.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75V3z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div class="summary-stat-content">
              <div class="summary-stat-value">
                {{
                  getBestMatchPercentage(matchedRecordDetails)
                    | number: "1.0-1"
                }}%
              </div>
              <div class="summary-stat-label-row">
                <span class="summary-stat-label">Best Match</span>
                <span
                  class="info-icon"
                  title="Highest match percentage score among all matching criteria for this CDFI"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="overall-products-section">
          <div class="section-header-row">
            <h4 class="section-title-overall">Overall Products Matched</h4>
            <span class="products-count-badge">
              {{ getDistinctProducts(matchedRecordDetails).length }}
            </span>
          </div>
          <div class="overall-products-container">
            @if (getDistinctProducts(matchedRecordDetails).length > 0) {
              @for (
                product of getDistinctProducts(matchedRecordDetails);
                track product
              ) {
                <span class="overall-product-tag">{{ product }}</span>
              }
            } @else {
              <span class="no-products-text">No products matched</span>
            }
          </div>
        </div>

        @if (showFullDetails && selectedCriteriaDetails) {
          <div class="criteria-tabs-wrapper">
            <span class="criteria-tabs-label">Leads Criteria:</span>
            @if (showLeftArrow) {
              <button
                type="button"
                class="scroll-arrow scroll-arrow-left"
                (click)="scrollTabs('left')"
                aria-label="Scroll left"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            }
            <div
              class="criteria-tabs-scroll-container"
              #criteriaTabsContainer
              (scroll)="updateScrollArrows()"
            >
              <div class="criteria-tabs">
                @for (
                  criterion of matchedRecordDetails.matched_criterias;
                  track criterion.name + criterion.data_source + $index
                ) {
                  <button
                    type="button"
                    class="criteria-tab"
                    [class.active]="criterion === selectedCriteriaDetails"
                    (click)="onSelectedCriteria(criterion)"
                  >
                    <span class="criteria-tab-title">{{ criterion.name }}</span>
                    <span class="criteria-tab-meta">
                      {{ criterion.match_percentage | number: "1.0-2" }}% |
                      {{ getSourceLabel(criterion.data_source) }} data
                    </span>
                  </button>
                }
              </div>
            </div>
            @if (showRightArrow) {
              <button
                type="button"
                class="scroll-arrow scroll-arrow-right"
                (click)="scrollTabs('right')"
                aria-label="Scroll right"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            }
          </div>

          <div class="popup-body">
            <div class="criteria-detail-card">
              <div class="criteria-match-header">
                <div class="match-percentage-section">
                  <div class="match-percentage-label">Match Percentage</div>
                  <div class="match-percentage-value">
                    {{
                      selectedCriteriaDetails.match_percentage
                        | number: "1.0-1"
                    }}%
                  </div>
                  <div class="match-progress-bar-container">
                    <div
                      class="match-progress-bar-fill"
                      [style.width.%]="selectedCriteriaDetails.match_percentage"
                    ></div>
                  </div>
                </div>
                <div class="criteria-metadata">
                  <div class="metadata-item">
                    <span class="metadata-label">Match Properties</span>
                    <span class="metadata-value">
                      {{ selectedCriteriaDetails.match_score }} /
                      {{ selectedCriteriaDetails.max_score }}
                    </span>
                  </div>
                  <div class="metadata-item">
                    <span class="metadata-label">Products Matched</span>
                    <span class="metadata-value">
                      {{
                        getMappedProductNames(
                          selectedCriteriaDetails.matched_criteria.products
                        ).length
                      }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="section criteria-detail-panel">
                <div class="detail-section-title-row">
                  <span class="section-title"
                    >Products Matched In This Criteria</span
                  >
                  <span class="section-count">{{
                    getMappedProductNames(
                      selectedCriteriaDetails.matched_criteria.products
                    ).length
                  }}</span>
                </div>
                <div class="tags-scroll-area detail-tags-area">
                  <div class="tags-container">
                    @if (
                      selectedCriteriaDetails &&
                      getMappedProductNames(
                        selectedCriteriaDetails.matched_criteria.products
                      ).length > 0
                    ) {
                      @for (
                        product of getMappedProductNames(
                          selectedCriteriaDetails.matched_criteria.products
                        );
                        track product
                      ) {
                        <span class="tag product-tag">{{ product }}</span>
                      }
                    } @else {
                      <span class="tag muted-tag"
                        >No product-specific match</span
                      >
                    }
                  </div>
                </div>
              </div>

              <div class="section criteria-detail-panel">
                <div class="detail-section-title-row">
                  <span class="section-title">Matched Properties</span>
                  <span class="section-count">{{
                    selectedCriteriaDetails.matched_criteria.matched_properties
                      .length
                  }}</span>
                </div>
                <div class="tags-scroll-area detail-tags-area">
                  <div class="tags-container">
                    @if (
                      selectedCriteriaDetails &&
                      selectedCriteriaDetails.matched_criteria
                        .matched_properties.length > 0
                    ) {
                      @for (
                        item of selectedCriteriaDetails.matched_criteria
                          .matched_properties;
                        track item
                      ) {
                        <span class="tag">{{ item }}</span>
                      }
                    } @else {
                      <span class="tag muted-tag"
                        >No property-specific match</span
                      >
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </section>
    </div>
  </app-popup>
}

@if (
  showConnectionsWithLoanAmount &&
  matchedConnectionsWithLoanAmount &&
  matchedConnectionsWithLoanAmount.length > 0
) {
  <app-popup
    [heading]="'Connections that serve loan amounts'"
    [popupPosition]="'absolute'"
    [showFooterButtons]="false"
    [showCloseIcon]="true"
    (cancelClicked)="onCancelShareConnectionsPopup()"
  >
    <div class="popup-content">
      <div class="connections-list-container">
        @for (
          connection of matchedConnectionsWithLoanAmount;
          track connection.connection_name
        ) {
          <div class="connection-item">
            <div class="checkbox-section">
              <label class="checkbox-container">
                <input
                  #chk
                  type="checkbox"
                  (change)="onConnectionSelected(chk.checked, connection)"
                />
                <span class="checkmark"></span>
              </label>
            </div>

            <div class="connection-name">
              {{ connection.display_name || connection.connection_name }}
            </div>
          </div>
        }
      </div>

      <div class="popup-actions-footer">
        <button
          class="share-submit-btn"
          [disabled]="!selectedConnectionForSharing?.length"
          (click)="onShareSelected()"
        >
          Share Selected ({{ selectedConnectionForSharing?.length || 0 }})
        </button>
      </div>
    </div>
  </app-popup>
}
